import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { BookOpen, Headphones, Sparkles, Clock } from 'lucide-react';
const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
export function OfferSection() {
  return <Section background="cream-dark" id="oferta" data-id="element-67">
      <div className="max-w-4xl mx-auto text-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-69">
          <div className="inline-flex items-center justify-center p-3 bg-[#C9A227]/20 rounded-full mb-6" data-id="element-70">
            <Sparkles className="w-6 h-6 text-[#C9A227]" data-id="element-71" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#3D2314] mb-6" data-id="element-72">
            Oferta del Pack Educativo
          </h2>

          <div className="w-24 h-1 bg-[#C9A227] mx-auto mb-8" data-id="element-73"></div>

          <p className="text-lg md:text-xl text-[#5C3D2E] mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-74">
            Accede al pack completo con los{' '}
            <strong data-id="element-75">3 libros digitales en PDF</strong> y sus{' '}
            <strong data-id="element-76">versiones en audio</strong> de los genios que transformaron
            la humanidad. Todo el conocimiento, listo para inspirarte.
          </p>

          <div className="flex flex-wrap justify-center gap-8 mb-10" data-id="element-77">
            <div className="flex items-center gap-3 text-[#3D2314]" data-id="element-78">
              <BookOpen className="w-6 h-6 text-[#C9A227]" data-id="element-79" />
              <span className="font-medium" data-id="element-80">3 Ebooks en PDF</span>
            </div>
            <div className="flex items-center gap-3 text-[#3D2314]" data-id="element-81">
              <Headphones className="w-6 h-6 text-[#C9A227]" data-id="element-82" />
              <span className="font-medium" data-id="element-83">3 Audiolibros</span>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-[#E0D8D0] max-w-md mx-auto" data-id="element-84">
            <div className="inline-flex items-center gap-2 bg-[#C9A227]/10 text-[#C9A227] px-4 py-2 rounded-full mb-4" data-id="element-85">
              <Clock className="w-4 h-4" data-id="element-86" />
              <span className="text-sm font-medium" data-id="element-87">
                Oferta de lanzamiento por tiempo limitado
              </span>
            </div>

            <p className="text-sm text-[#5C3D2E] mb-4" data-id="element-88">
              Antes <span className="line-through" data-id="element-89">24,95 €</span> – Ahora
            </p>

            <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-90">
              <span className="text-5xl md:text-6xl font-serif font-bold text-[#3D2314]" data-id="element-91">
                14,95
              </span>
              <span className="text-2xl font-serif text-[#3D2314]" data-id="element-92">€</span>
            </div>

            <p className="text-xs text-[#C9A227] font-medium mb-6" data-id="element-93">
              ¡Ahorra 10 €!
            </p>

            <p className="text-sm text-[#5C3D2E] mb-8" data-id="element-94">
              Acceso inmediato · Pago único · Sin suscripción
            </p>
            <Button size="lg" withIcon className="w-full" onClick={() => scrollToSection('comprar')} data-id="element-95">
              Comprar ahora
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </Section>;
}